<template>
<div class="productPage">
	<div class="productImageBox" ref="headerImageRef">
		<img class="productImage" src="@/assets/productIMG.png" />
		<div class="productTextBox">
			<div class="productTitle" style="margin-top: 3rem;">
				八品矩阵，织就全周期健康守护网<br />
				<span style="font-size: 4rem;">
					8 Products, A Full-Life Wellness Safety Net
				</span>
			</div>
			<div class="productText" style="margin-top: 3rem;">
				从心愈到身养，每一种需求皆有回响<br />
				From Healing to Wellness, Every Need Answered
			</div>
		</div>

		<div class="productSelectBox">
			<template v-for="(item, index) in productList">
				<div style="width: 1px; height: 2.7rem; background-color: rgba(255, 255, 255, 0.85); opacity: 0.6;" v-if="index != 0" />
				<div class="productSelectItem" :class="{ active: index === currentProdact }" @mouseenter="viewProduct(index)">
					{{ item.name }}
				</div>
			</template>
		</div>
	</div>

	<div style="height: 11.7rem; width: 1px;" />
	<div class="productShowCase">
		<transition name="fade-slide" mode="out-in">
			<div class="productShowCaseInner" :key="currentProdact">
			<div class="productFlexBox">
				<div class="productDetailBox" style="margin-left: 4.2rem;">
				<img class="productDetailIcon" src="@/assets/product00.png" />
				<div class="productDetailTitle">核心定位</div>
				<div class="productDetailDesc">{{ productList[currentProdact].desc1 }}</div>
				</div>

				<div style="height: 2.5rem; width: 1px;" />

				<div class="productDetailBox">
				<img class="productDetailIcon" src="@/assets/product01.png" />
				<div class="productDetailTitle">核心功能</div>
				<div class="productDetailDesc">{{ productList[currentProdact].desc2 }}</div>
				</div>

				<div style="height: 2.5rem; width: 1px;" />

				<div class="productDetailBox" style="margin-left: 4.2rem;">
				<img class="productDetailIcon" src="@/assets/product02.png" />
				<div class="productDetailTitle">产品亮点</div>
				<div class="productDetailDesc">{{ productList[currentProdact].desc3 }}</div>
				</div>
			</div>

			<div style="width: 2.9rem; height: 1px;" />

			<div class="productFlexBox">
				<img :src="productList[currentProdact].image" class="productImage" />
			</div>
			</div>
		</transition>
	</div>
	<div style="height: 11.7rem; width: 1px;" />

</div>
</template>

<script>
export default {
	data() {
		return {
			currentProdact: 0,
			productList: [
				{
					name: 'PULSE 治愈',
					desc1: '智慧自适应心理疗愈平台',
					desc2: '冥想课程、虚拟咨询师、OH 卡工具、情绪测评、场景化情绪解决方案',
					desc3: '轻量化内容、趣味化形式、人气声优配音、7×24 小时陪伴',
					image: require('@/assets/product0.png'),
				},
				{
					name: 'PULSE 健康',
					desc1: '垂直病种 “心理 + 生理” 一体化康复工具',
					desc2: '多维度健康建档、权威数字处方、症状监测、医患联动通道',
					desc3: '三甲医院专家定制、康复效果可量化、生理心理同步管理',
					image: require('@/assets/product1.png'),
				},
				{
					name: '健康脑',
					desc1: '老年认知健康管理工具',
					desc2: '阿尔兹海默症筛查、脑健康评估、个性化训练、就医预约',
					desc3: '操作简单、权威量表、社区适配、医疗资源对接',
					image: require('@/assets/product2.png'),
				},
				{
					name: '职工心理（企业 EAP 系统）',
					desc1: '企业员工心理健康一体化管理平台',
					desc2: '员工心理体检、分级预警、团体辅导、管理决策看板',
					desc3: '组织画像分析、多场景课程、隐私保护、高效部署',
					image: require('@/assets/product3.png'),
				},
				{
					name: '青少年心理系统',
					desc1: '教育场景心理健康管理平台',
					desc2: '筛查测评、动态监测、分级预警、“一生一档”、家校协同',
					desc3: '政策适配、多角色权限、数据可视化、教师赋能工具',
					image: require('@/assets/product4.png'),
				},
				{
					name: '青松心理',
					desc1: '政企专属心理服务品牌',
					desc2: '职场压力测评、AI 情绪疏导、团体活动预约、心理科普',
					desc3: '定制化内容、专业干预、高效响应、品牌化呈现',
					image: require('@/assets/product5.png'),
				},
				{
					name: '阴转晴',
					desc1: '中重度心理困扰专业咨询平台',
					desc2: '7×24 小时心理助理、咨询师预约、匿名倾诉、系统化课程',
					desc3: '专业咨询师团队、隐私保障、危机干预、效果跟踪',
					image: require('@/assets/product6.png'),
				},
				{
					name: '心愿绘本',
					desc1: 'AI 赋能显化工具',
					desc2: 'AI 愿望生成、每日打卡签到追踪、显化日记',
					desc3: '创意化表达、心理暗示赋能、轻量化互动',
					image: require('@/assets/product7.png'),
				},
			],
		}
	},
	methods: {
		viewProduct(index) {
			this.currentProdact = index;
		},

		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
	},
}
</script>

<style lang="scss" scoped>
.productPage {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	
	.productImageBox {
		width: 100%;
		min-width: 120rem;
		height: 51.4rem;
		position: relative;
		background-color: #212121;

		.productImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}

		.productTextBox {
			position: absolute;
			width: 1200px;
			left: calc((100% - 1200px) / 2);
			top: 20%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.productTitle {
				font-size: 5.3rem;
				text-align: left;
				color: #FFFFFF;
			}
			.productText {
				font-size: 1.5rem;
				line-height: 2.5rem;
				text-align: left;
				color: #FFFFFF;
			}
		}

		.productSelectBox {
			position: absolute;
			width: 100%;
			bottom: 2.2rem;
			left: 0;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			background-color: rgba(0, 0, 0, 0.05);

			.productSelectItem {
				margin-left: 1.6rem;
				margin-right: 1.6rem;
				font-size: 1.7rem;
				line-height: 2.7rem;
				color: rgba(255, 255, 255, 0.85);
				cursor: pointer;
				border-bottom: 1px solid transparent;
			}
			.productSelectItem:hover {
				opacity: 0.5;
				transition: color 0.3s ease, opacity 0.3s ease;
			}

			.productSelectItem.active,
			.productSelectItem.active:hover {
				opacity: 1;
				color: #78DFA2;
				border-bottom: 0.2rem solid #78DFA2;
			}
		}
	}

	.productShowCase {
		width: 100rem;
		height: 55.7rem;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;

		.productShowCaseInner {
			width: 100%;
			height: 100%;
			display: flex;

			.productFlexBox {
				flex: 1;
				height: 100%;
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				.productDetailBox {
					width: 36.7rem;
					height: 12.3rem;
					border-radius: 0.8rem;
					box-shadow: 0px 0.3rem 3.3rem 0px rgba(51, 51, 51, 0.05);
					position: relative;

					.productDetailIcon {
						position: absolute;
						top: 2.5rem;
						left: 2.5rem;
						width: 4.2rem;
						height: 4.2rem;
					}
					.productDetailTitle {
						position: absolute;
						top: 2.5rem;
						left: 8.3rem;
						color: #333333;
						font-size: 1.7rem;
						line-height: 2.7rem;
					}
					.productDetailDesc {
						position: absolute;
						top: 5.5rem;
						left: 8.3rem;
						width: 25.8rem;
						text-align: left;
						color: #333333;
						font-size: 1.5rem;
						line-height: 2.4rem;
						opacity: 0.7;
					}
				}

				.productImage {
					position: absolute;
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}
		}

		
	}
	
}

.fade-slide-enter-active,
.fade-slide-leave-active {
	transition: opacity 0.45s ease, transform 0.45s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
	opacity: 0;
	transform: translateX(24px); // 想向左滑就改成 -24px
}
</style>